import React, { Component } from 'react';
import Button from '../Button/Button';
import LoginPageIllustration from './LoginPageIllustration';
import { withGlobalContext } from '../../App';
import { NOTIFICATIONS } from '../../constants';
import './login_page.scss';

export class LoginPage extends Component {
  componentDidMount() {
    if (this.props.location.search.includes('returnTo')) {
      this.props.createNotification({
        message: `Your session has expired. Please login again`,
        type: NOTIFICATIONS.TYPE.ERROR,
        timeout: 3000,
      });
    }
  }

  render() {
    return (
      <div className="login_page flex">
        <section className="title_wrapper relative w-1/2 h-screen px-4 py-4 bg-lightGreen text-center">
          <div className="content_wrapper absolute l-50 translate-50-50">
            <h1 className="font-light italic mb-4 mt-0 mt-0">Clippy</h1>
            <h3 className="font-medium mb-16 mt-0 text-lg">The next-gen CMS</h3>
            <a href={`/oauth${this.props.location.search}`}>
              <Button type="black-white" className="px-6 py-3 text-2xl">
                Login to continue
              </Button>
            </a>
          </div>
        </section>
        <section className="illustration_wrapper w-1/2 h-screen relative px-4 py-4 bg-white">
          <LoginPageIllustration />
        </section>
      </div>
    );
  }
}

export default  withGlobalContext(LoginPage);
